import { Component, OnInit } from '@angular/core';
import {GlobalService} from '../global.service';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.sass']
})
export class ForgotpasswordComponent implements OnInit {
  public forgotPasawordStatus:number;
  public email:string;
  public emailToSend:string;
  public subscriber:string;
  public newpass;
  public token;
  public encryption:boolean;
  public ResponseList:string;
  public productType:string;

  constructor(public AngularFireAnalytics:AngularFireAnalytics, public loadingScreenService:LoadingScreenService, private global:GlobalService) {
    this.AngularFireAnalytics.setCurrentScreen("¿Olvidaste tu contraseña?");
    this.AngularFireAnalytics.logEvent("¿Olvidaste tu contraseña?-Screenview");
   }

  ngOnInit() {
    if(this.global.requiredPasswordReset==true){
      this.forgotPasawordStatus=3;
      this.encryption=true;
    }
    else{
      this.forgotPasawordStatus=1;
      this.encryption=false;
    }
  }
}
